import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VideoCallStadisticsModel } from 'src/app/models/VideoCallStadistics.model';
import { VideoconsultaBackendService } from 'src/app/services/videoconsulta-backend.service';
import { getSpecificDateType } from 'src/app/utils/utils';

@Component({
  selector: 'app-finalizado',
  templateUrl: './finalizado.component.html',
  styleUrls: ['./finalizado.component.css'],
})
export class FinalizadoComponent implements OnInit {
  cid: number;
  isMedic: number;
  fechaMedic: string;
  fechaPaciente: string;

  constructor(
    private _videoconsulta: VideoconsultaBackendService,
    public route: ActivatedRoute
  ) {}

  ngOnInit() {
    const nav = history.state;
    this.cid = parseInt(nav.cid);
    this.isMedic = parseInt(nav.m);

    localStorage.removeItem('token');

    this.getStadisticsByCid();

    window.onpopstate = async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
    };
  }

  getStadisticsByCid() {
    if (this.cid > 0) {
      this._videoconsulta.statsByCid(this.cid).subscribe({
        next: (resp: VideoCallStadisticsModel) => {
          if (!this.isMedic && resp.patientFinalizedAt != null) {
            this.fechaPaciente = resp.patientFinalizedAt;
          } else {
            this.fechaPaciente = getSpecificDateType('YYYY-MM-DD HH:mm:ss');
          }

          if (this.isMedic && resp.medicFinalizedAt != null) {
            this.fechaMedic = resp.medicFinalizedAt;
          } else {
            this.fechaMedic = getSpecificDateType('YYYY-MM-DD HH:mm:ss');
          }
        },
        error: (err) => err && console.log(err),
      });
    }
  }
}
